





























import { Component, Prop, Vue } from 'vue-property-decorator'

import DateOutput from '~/components/DateOutput.vue'
import BBSpriteIcon from '~/components/BB/BBSpriteIcon.vue'

@Component({
  components: {
    BBSpriteIcon,
    DateOutput
  }
})
export default class Alert extends Vue {
  @Prop({
    type: String,
    required: true
  })
  icon: string

  @Prop({
    type: Date,
    default: null
  })
  date: null | string
}
